module.exports = __webpack_public_path__ + "img/jbt9163_15_1999.prt.e5f5e35f.jpg";